import { Setup } from './Setup';

// TODO: Add scopes
export const SetupConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'setupCompany',
      path: 'setup',
      element: <Setup />,
    },
  ],
};
